export default "__VITE_ASSET__BwqpWePF__"